import { httpClient } from '@/shared/api/client.ts'
import { InfoResponse } from '@/domains/auth/api/types'

export function fetchInfo() {
  return httpClient.get('member').json<InfoResponse>()
}
